'use client';

import { usePathname } from 'next/navigation';
import { PartnerLink } from './PartnerLink';
import { IMG } from '../imgPrefix';

/**
 * Site footer (extracted from the root layout so it can self-hide). Renders on every route EXCEPT
 * the white-label plugin embed (`/booking-engine-landing`), which is iframe content and must carry
 * no site chrome. Mirrors the Navbar's same self-hide.
 */
export function SiteFooter() {
  const pathname = usePathname() || '';
  if (pathname.startsWith('/booking-engine-landing')) return null;

  return (
    <footer>
      <div id="ihqxv" className="container mx-auto px-4 pb-5 lg:pb-0 mb-3">
        <p className="pb-0 mb-4 pt-4">
          <a href="/">
            <img id="i3sj8" src={`${IMG}/image/purple-new_logo.png`} alt="Footer Logo" />
          </a>
        </p>
        <div className="flex flex-wrap -mx-3">
          <div className="w-1/2 md:w-1/4 px-3 footer-link pb-3">
            <h6 className="large">Company</h6>
            <ul className="footer-section">
              <li>
                <a href="/about-book-it-please">About Book It Please</a>
              </li>
              <li>
                <a href="/our-partners">Our Partners</a>
              </li>
              <li>
                <PartnerLink />
              </li>
              <li>
                <a href="/privacy-policy" target="_blank">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms-and-conditions" target="_blank">
                  Terms and Conditions
                </a>
              </li>
              <li>
                <a href="/event-manager" target="_blank">
                  Event Manager
                </a>
              </li>
            </ul>
          </div>
          <div className="w-1/2 md:w-1/4 px-3 footer-link pb-3">
            <h6 className="large">Support</h6>
            <ul className="footer-section">
              <li>
                <a href="/faqs" target="_blank">
                  FAQs
                </a>
              </li>
              <li>
                <a href="/contact" target="_blank">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          <div className="w-1/2 md:w-1/4 px-3 footer-link pb-3">
            <h6 className="large">Social</h6>
            <ul className="footer-section">
              <li>
                <a
                  href="https://www.facebook.com/people/Book-It-Please/61574207954853/"
                  target="_blank"
                >
                  <i className="fab fa-facebook mr-2"></i>Facebook
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/book.it.please/?hl=en" target="_blank">
                  <i className="fab fa-instagram mr-2"></i>Instagram
                </a>
              </li>
            </ul>
          </div>
          <div className="w-1/2 md:w-1/4 px-3 footer-link pb-3">
            <h6 className="large">Inspiration</h6>
            <ul className="footer-section">
              <li>
                <a href="/travel" target="_blank">
                  Travel Articles
                </a>
              </li>
            </ul>
          </div>
          <div className="w-full text-center">
            <p>Copyright &copy; 2026 Bookitplease.com</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
